import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col gap-3',
    title: 'heading-s-bold',
    ratingsContainer: 'flex flex-col gap-2',
    ratingButton: 'flex cursor-pointer items-center gap-5',
    rating: 'flex w-7.5 items-center gap-1',
    ratingValue: 'heading-s',
    star: 'text-icon-star size-4',
    count: 'heading-s w-9 text-right',
    ratingBar: 'relative grow',
    ratingBarLine:
      'bg-bg-secondary absolute inset-x-0 top-1/2 h-px -translate-y-1/2 rounded-full',
    ratingBarFill:
      'bg-blue-dark absolute top-1/2 h-[3px] -translate-y-1/2 rounded-full'
  },
  variants: {
    selected: {
      true: {
        ratingValue: 'heading-s-bold'
      }
    }
  }
});
